import { logError } from "@/shared/logging/errors";

import type { ImagePicker } from "@/portal/formControls/ImagePicker";

export class ImageHelper {
    // resolves false when the source image could not be downloaded, so the caller can say that the
    // copy is missing an image instead of quietly saving it without one
    public static carryOverImage<T>(picker: ImagePicker<T>, path: string | undefined): Promise<boolean> {
        if (path == null) return Promise.resolve(true);

        return fetch(path)
            .then((response) => (response.ok ? response.blob() : undefined))
            .then((blob) => {
                if (blob === undefined) return false;

                // the operator may have replaced or removed the image while it was loading
                if (picker.pendingFile !== undefined || picker.hasPendingDelete) return true;

                picker.setPendingUpload(new File([blob], "image.jpg", { type: blob.type }));

                return true;
            })
            .catch((ex) => {
                logError(ex);

                return false;
            });
    }
}
